// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Professional Table Action Bar Styling */
.table-action-bar {
  --action-button-width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem 2rem;
  background: #2d3748;
  border-radius: 0;
  gap: 1.5rem;
  border-bottom: 1px solid #4a5568;
}

.action-group {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}

.action-group .action-button {
  flex: 1 1 var(--action-button-width);
}

.secondary-actions .status-dropdown-wrapper {
  flex: 1 1 var(--action-button-width);
  min-width: var(--action-button-width);
  display: flex;
  align-items: stretch;
}

.primary-actions {
  flex: 1 1;
  justify-content: flex-start;
}

.secondary-actions {
  flex: 1 1;
  justify-content: flex-end;
}

.action-divider {
  width: 1px;
  height: 2.5rem;
  background: linear-gradient(
    to bottom,
    transparent 0%,
    rgba(255, 255, 255, 0.2) 20%,
    rgba(255, 255, 255, 0.2) 80%,
    transparent 100%
  );
  flex-shrink: 0;
}

.action-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.875rem;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  min-width: var(--action-button-width);
  justify-content: center;
}

.action-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, transparent 50%, rgba(0, 0, 0, 0.1) 100%);
  opacity: 0;
  transition: opacity 0.2s ease;
  pointer-events: none;
}

.action-button:hover::before {
  opacity: 1;
}

.action-button:hover {
  transform: translateY(-2px);
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.15),
    0 2px 8px rgba(0, 0, 0, 0.1);
}

.action-button:active {
  transform: translateY(0);
}

.action-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.action-button:disabled:hover {
  transform: none;
  box-shadow:
    0 2px 8px rgba(0, 0, 0, 0.1),
    0 1px 4px rgba(0, 0, 0, 0.05);
}

.action-button:disabled::before {
  opacity: 0;
}

.table-action-bar .btn-primary {
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  color: white;
  min-width: var(--action-button-width);
}

.table-action-bar .btn-primary:hover {
  background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
}

.table-action-bar .btn-success {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  min-width: var(--action-button-width);
}

.table-action-bar .btn-success:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
}

.table-action-bar .btn-warning {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  min-width: var(--action-button-width);
}

.table-action-bar .btn-warning:hover {
  background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
}

.table-action-bar .btn-danger {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  min-width: var(--action-button-width);
}

.table-action-bar .btn-danger:hover {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
}

.table-action-bar .btn-secondary {
  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
  color: white;
  min-width: var(--action-button-width);
}

.table-action-bar .btn-secondary:hover {
  background: linear-gradient(135deg, #4b5563 0%, #374151 100%);
}

.table-action-bar .btn-info {
  background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
  color: white;
  min-width: var(--action-button-width);
}

.table-action-bar .btn-info:hover {
  background: linear-gradient(135deg, #0891b2 0%, #0e7490 100%);
}

/* Status dropdown enhancements */
.status-dropdown-toggle {
  display: inline-flex !important;
  align-items: center;
  gap: 0.65rem;
  padding-right: 2.5rem !important;
  position: relative;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  min-width: var(--action-button-width);
  width: 100%;
}

.status-dropdown-toggle:after {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  content: '\\25BE';
  font-size: 0.65rem;
  color: rgba(255, 255, 255, 0.75);
}

.status-label {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 700;
}

.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.25);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.status-dot.status-running {
  background: #34d399;
  box-shadow: 0 0 10px rgba(52, 211, 153, 0.7);
}

.status-dot.status-stopped {
  background: #f87171;
  box-shadow: 0 0 10px rgba(248, 113, 113, 0.6);
}

.status-dot.status-unknown {
  background: #9ca3af;
  box-shadow: 0 0 8px rgba(156, 163, 175, 0.5);
}

.status-dropdown-menu {
  background: #1f2937;
  border: 1px solid #374151;
  box-shadow:
    0 12px 20px rgba(15, 23, 42, 0.35),
    0 4px 8px rgba(15, 23, 42, 0.25);
  border-radius: 14px;
  padding: 0.5rem;
  min-width: 180px;
}

.status-dropdown-item {
  border-radius: 10px;
  padding: 0.45rem 0.75rem;
  color: #e5e7eb;
  transition:
    transform 0.2s ease,
    background 0.2s ease;
}

.status-dropdown-item:hover,
.status-dropdown-item:focus {
  background: rgba(148, 163, 184, 0.12);
  transform: translateX(4px);
}

.status-dropdown-item.status-running:hover,
.status-dropdown-item.status-running.is-active {
  background: rgba(16, 185, 129, 0.15);
  color: #34d399;
}

.status-dropdown-item.status-running .status-option-text {
  color: #a7f3d0;
}

.status-dropdown-item.status-stopped:hover,
.status-dropdown-item.status-stopped.is-active {
  background: rgba(239, 68, 68, 0.18);
  color: #f87171;
}

.status-dropdown-item.status-stopped .status-option-text {
  color: #fecaca;
}

.status-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.status-option-text {
  flex: 1 1;
}

.status-option .status-dot {
  width: 9px;
  height: 9px;
}

.status-option-check {
  font-size: 0.9rem;
  opacity: 0.85;
}

.status-dropdown-item.is-active .status-option-check {
  opacity: 1;
}

.status-dropdown-item:disabled {
  opacity: 0.5;
  transform: none;
}

.status-dropdown-item:disabled:hover {
  background: transparent;
  transform: none;
}

/* Spinner Animation */
.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  flex-shrink: 0;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.action-icon {
  font-size: 1rem;
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.action-button:hover .action-icon {
  transform: scale(1.1);
}

.button-text {
  flex-shrink: 0;
  font-weight: 600;
  letter-spacing: 0.025em;
}

/* Focus states for accessibility */
.action-button:focus-visible {
  outline: 2px solid rgba(139, 92, 246, 0.5);
  outline-offset: 2px;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .table-action-bar {
    padding: 1rem 1.5rem;
    gap: 1rem;
  }

  .action-group {
    gap: 0.5rem;
  }

  .action-button {
    padding: 0.625rem 1rem;
    font-size: 0.8rem;
  }
}

@media (max-width: 1024px) {
  .table-action-bar {
    padding: 1rem 1.25rem;
    flex-direction: column;
    gap: 0.75rem;
  }

  .primary-actions,
  .secondary-actions {
    flex: none;
    justify-content: center;
  }

  .action-divider {
    width: 60%;
    height: 1px;
    background: linear-gradient(
      to right,
      transparent 0%,
      rgba(255, 255, 255, 0.2) 20%,
      rgba(255, 255, 255, 0.2) 80%,
      transparent 100%
    );
  }
}

@media (max-width: 768px) {
  .table-action-bar {
    padding: 1rem;
  }

  .action-group {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    grid-gap: 0.75rem;
    gap: 0.75rem;
    width: 100%;
  }

  .action-button {
    padding: 0.75rem 0.5rem;
    font-size: 0.75rem;
    min-width: 0;
    min-width: initial;
    width: 100%;
    justify-content: center;
  }

  .button-text {
    display: block;
  }
}

@media (max-width: 480px) {
  .action-group {
    grid-template-columns: 1fr;
  }

  .action-button {
    padding: 0.875rem 1rem;
    font-size: 0.875rem;
  }

  .action-divider {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PokerTable/TableActionBar.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,cAAc;EACd;;;;;;GAMC;EACD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iDAAiD;EACjD,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0GAA0G;EAC1G,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B;;gCAE8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf;;iCAE+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA,iCAAiC;AACjC;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,8CAA8C;EAC9C;;wBAEsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB;;oCAEkC;EAClC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,cAAc;EACd;;wBAEsB;AACxB;;AAEA;;EAEE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;;EAEE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,sBAAsB;IACtB,YAAY;EACd;;EAEA;;IAEE,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,WAAW;IACX;;;;;;KAMC;EACH;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,iBAAY;IAAZ,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,YAAgB;IAAhB,kBAAgB;IAChB,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Professional Table Action Bar Styling */\n.table-action-bar {\n  --action-button-width: 180px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.25rem 2rem;\n  background: #2d3748;\n  border-radius: 0;\n  gap: 1.5rem;\n  border-bottom: 1px solid #4a5568;\n}\n\n.action-group {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.action-group .action-button {\n  flex: 1 1 var(--action-button-width);\n}\n\n.secondary-actions .status-dropdown-wrapper {\n  flex: 1 1 var(--action-button-width);\n  min-width: var(--action-button-width);\n  display: flex;\n  align-items: stretch;\n}\n\n.primary-actions {\n  flex: 1;\n  justify-content: flex-start;\n}\n\n.secondary-actions {\n  flex: 1;\n  justify-content: flex-end;\n}\n\n.action-divider {\n  width: 1px;\n  height: 2.5rem;\n  background: linear-gradient(\n    to bottom,\n    transparent 0%,\n    rgba(255, 255, 255, 0.2) 20%,\n    rgba(255, 255, 255, 0.2) 80%,\n    transparent 100%\n  );\n  flex-shrink: 0;\n}\n\n.action-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.25rem;\n  border: none;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 0.875rem;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  white-space: nowrap;\n  min-width: var(--action-button-width);\n  justify-content: center;\n}\n\n.action-button::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, transparent 50%, rgba(0, 0, 0, 0.1) 100%);\n  opacity: 0;\n  transition: opacity 0.2s ease;\n  pointer-events: none;\n}\n\n.action-button:hover::before {\n  opacity: 1;\n}\n\n.action-button:hover {\n  transform: translateY(-2px);\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.15),\n    0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.action-button:active {\n  transform: translateY(0);\n}\n\n.action-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.action-button:disabled:hover {\n  transform: none;\n  box-shadow:\n    0 2px 8px rgba(0, 0, 0, 0.1),\n    0 1px 4px rgba(0, 0, 0, 0.05);\n}\n\n.action-button:disabled::before {\n  opacity: 0;\n}\n\n.table-action-bar .btn-primary {\n  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);\n  color: white;\n  min-width: var(--action-button-width);\n}\n\n.table-action-bar .btn-primary:hover {\n  background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);\n}\n\n.table-action-bar .btn-success {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  min-width: var(--action-button-width);\n}\n\n.table-action-bar .btn-success:hover {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n}\n\n.table-action-bar .btn-warning {\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: white;\n  min-width: var(--action-button-width);\n}\n\n.table-action-bar .btn-warning:hover {\n  background: linear-gradient(135deg, #d97706 0%, #b45309 100%);\n}\n\n.table-action-bar .btn-danger {\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n  color: white;\n  min-width: var(--action-button-width);\n}\n\n.table-action-bar .btn-danger:hover {\n  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);\n}\n\n.table-action-bar .btn-secondary {\n  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);\n  color: white;\n  min-width: var(--action-button-width);\n}\n\n.table-action-bar .btn-secondary:hover {\n  background: linear-gradient(135deg, #4b5563 0%, #374151 100%);\n}\n\n.table-action-bar .btn-info {\n  background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);\n  color: white;\n  min-width: var(--action-button-width);\n}\n\n.table-action-bar .btn-info:hover {\n  background: linear-gradient(135deg, #0891b2 0%, #0e7490 100%);\n}\n\n/* Status dropdown enhancements */\n.status-dropdown-toggle {\n  display: inline-flex !important;\n  align-items: center;\n  gap: 0.65rem;\n  padding-right: 2.5rem !important;\n  position: relative;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  min-width: var(--action-button-width);\n  width: 100%;\n}\n\n.status-dropdown-toggle:after {\n  position: absolute;\n  right: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  border: none;\n  content: '\\25BE';\n  font-size: 0.65rem;\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.status-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 700;\n}\n\n.status-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 999px;\n  box-shadow: 0 0 10px rgba(255, 255, 255, 0.25);\n  transition:\n    transform 0.2s ease,\n    box-shadow 0.2s ease;\n}\n\n.status-dot.status-running {\n  background: #34d399;\n  box-shadow: 0 0 10px rgba(52, 211, 153, 0.7);\n}\n\n.status-dot.status-stopped {\n  background: #f87171;\n  box-shadow: 0 0 10px rgba(248, 113, 113, 0.6);\n}\n\n.status-dot.status-unknown {\n  background: #9ca3af;\n  box-shadow: 0 0 8px rgba(156, 163, 175, 0.5);\n}\n\n.status-dropdown-menu {\n  background: #1f2937;\n  border: 1px solid #374151;\n  box-shadow:\n    0 12px 20px rgba(15, 23, 42, 0.35),\n    0 4px 8px rgba(15, 23, 42, 0.25);\n  border-radius: 14px;\n  padding: 0.5rem;\n  min-width: 180px;\n}\n\n.status-dropdown-item {\n  border-radius: 10px;\n  padding: 0.45rem 0.75rem;\n  color: #e5e7eb;\n  transition:\n    transform 0.2s ease,\n    background 0.2s ease;\n}\n\n.status-dropdown-item:hover,\n.status-dropdown-item:focus {\n  background: rgba(148, 163, 184, 0.12);\n  transform: translateX(4px);\n}\n\n.status-dropdown-item.status-running:hover,\n.status-dropdown-item.status-running.is-active {\n  background: rgba(16, 185, 129, 0.15);\n  color: #34d399;\n}\n\n.status-dropdown-item.status-running .status-option-text {\n  color: #a7f3d0;\n}\n\n.status-dropdown-item.status-stopped:hover,\n.status-dropdown-item.status-stopped.is-active {\n  background: rgba(239, 68, 68, 0.18);\n  color: #f87171;\n}\n\n.status-dropdown-item.status-stopped .status-option-text {\n  color: #fecaca;\n}\n\n.status-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.status-option-text {\n  flex: 1;\n}\n\n.status-option .status-dot {\n  width: 9px;\n  height: 9px;\n}\n\n.status-option-check {\n  font-size: 0.9rem;\n  opacity: 0.85;\n}\n\n.status-dropdown-item.is-active .status-option-check {\n  opacity: 1;\n}\n\n.status-dropdown-item:disabled {\n  opacity: 0.5;\n  transform: none;\n}\n\n.status-dropdown-item:disabled:hover {\n  background: transparent;\n  transform: none;\n}\n\n/* Spinner Animation */\n.spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid currentColor;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  flex-shrink: 0;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.action-icon {\n  font-size: 1rem;\n  flex-shrink: 0;\n  transition: transform 0.2s ease;\n}\n\n.action-button:hover .action-icon {\n  transform: scale(1.1);\n}\n\n.button-text {\n  flex-shrink: 0;\n  font-weight: 600;\n  letter-spacing: 0.025em;\n}\n\n/* Focus states for accessibility */\n.action-button:focus-visible {\n  outline: 2px solid rgba(139, 92, 246, 0.5);\n  outline-offset: 2px;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .table-action-bar {\n    padding: 1rem 1.5rem;\n    gap: 1rem;\n  }\n\n  .action-group {\n    gap: 0.5rem;\n  }\n\n  .action-button {\n    padding: 0.625rem 1rem;\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 1024px) {\n  .table-action-bar {\n    padding: 1rem 1.25rem;\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .primary-actions,\n  .secondary-actions {\n    flex: none;\n    justify-content: center;\n  }\n\n  .action-divider {\n    width: 60%;\n    height: 1px;\n    background: linear-gradient(\n      to right,\n      transparent 0%,\n      rgba(255, 255, 255, 0.2) 20%,\n      rgba(255, 255, 255, 0.2) 80%,\n      transparent 100%\n    );\n  }\n}\n\n@media (max-width: 768px) {\n  .table-action-bar {\n    padding: 1rem;\n  }\n\n  .action-group {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n    gap: 0.75rem;\n    width: 100%;\n  }\n\n  .action-button {\n    padding: 0.75rem 0.5rem;\n    font-size: 0.75rem;\n    min-width: unset;\n    width: 100%;\n    justify-content: center;\n  }\n\n  .button-text {\n    display: block;\n  }\n}\n\n@media (max-width: 480px) {\n  .action-group {\n    grid-template-columns: 1fr;\n  }\n\n  .action-button {\n    padding: 0.875rem 1rem;\n    font-size: 0.875rem;\n  }\n\n  .action-divider {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
